export default __webpack_public_path__ + "static/media/dk.17d826c2.png";